<template>
    <div class="main-content " v-cloak>
        <div v-if="user_data_loaded">
            <div class="container">
                <div class="text-container" style="margin-bottom: 2.4rem;" v-if="show_update_method_block">
                    <div class="red" style="margin-bottom:0;">Update your card/credit card details</div>
                    <p
                        style="max-width: 30rem;"
                        v-if="user.active_subscriptions && user.active_subscriptions.length > 0"
                    >
                        Your card/credit card will be expired! You won’t be charged immediately. The next charge will
                        take place on {{ getDate(user.active_subscriptions[0].next_billing_date) }}.
                    </p>
                    <div class="btn-container" style="display:flex;margin-top:0;">
                        <a @click="update" href="javascript:{}" :class="{ 'btn btn-default': true }"
                            >Update payment info</a
                        >
                    </div>
                </div>
                <div v-if="payment_change_modal_shown">
                    <payment-change-modal v-if="payment_change_modal_shown" @close-modal="hidePaymentChangeModal">
                    </payment-change-modal>
                </div>
            </div>

            <div class="container" v-if="user && user.active_plan && user.active_plan.is_trial">
                <div class="text-container">
                    <div class="title">Trial version</div>
                    <div class="red" v-if="user.active_plan.days_left && user.active_plan.days_left > 0">
                        Ends after {{ user.active_plan.days_left }} days
                    </div>
                    <p>After trial, all the functionality will be deactivated, but we do not delete your data.<br /></p>
                    <p v-if="false">Monthly payment amount will be <span>4.99€</span></p>
                </div>
                <div class="bttn-container" v-if="false">
                    <a
                        class="btn-primary"
                        @click="$router.push({ path: '/settings/subscription' })"
                        href="javascript:{}"
                        >Subscribe</a
                    >
                </div>
            </div>
            <div class="container" v-if="user && user.active_plan && user.active_plan.id && !user.active_plan.is_trial">
                <div class="text-container">
                    <div class="title">{{ user.active_plan.title }}</div>
                    <div class="price">{{ user.active_plan.title }} 4.99€/month</div>
                    <p>
                        You can unsubscribe at any time.
                    </p>
                    <p v-if="user.active_subscriptions.length === 0">
                        Your subscription has been canceled. <br />
                        It's valid until {{ user.active_plan.valid_until }}
                    </p>
                </div>
                <div class="bttn-container unsubscribe">
                    <a
                        v-if="user.active_subscriptions && user.active_subscriptions.length > 0"
                        @click="unsub"
                        class="btn-default"
                        href="javascript:{}"
                        >Unsubscribe</a
                    >
                    <a v-if="false" @click="sub" class="btn-default" href="javascript:{}">Subscribe</a>
                </div>
            </div>
            <div class="container landing" v-if="user && user.active_plan && !user.active_plan.id">
                <div class="text-container" v-if="!user.free_trial_used">
                    <p>No active subscription</p>
                </div>
                <div class="text-container" v-else>
                    <p class=""><span>Your trial has ended!</span></p>

                    <p v-if="false">
                        To keep using wplan please subscribe, <br />
                        it takes only a couple of minutes.
                    </p>
                </div>

                <div v-if="show_payment_modal">
                    <payment-modal :price="total_sum" :shown="true" @close-modal="closePaymentModal"></payment-modal>
                </div>
                <div class="pricing-options" v-if="false">
                    <div class="pl-title">Choose a plan:</div>
                    <div class="plans-container">
                        <div class="pricing-plan-container planner" style="margin-left:0;">
                            <div class="pricing-plan">
                                <div class="pricing-plan-content">
                                    <div class="plan-title">Planner</div>
                                    <div class="pricing-plan-price">
                                        <span class="pricing-plan-currency">€</span>4
                                        <span class="pricing-plan-cents">.99</span>
                                    </div>
                                    <div class="pricing-plan-price-text">per month</div>
                                </div>
                            </div>

                            <div class="pricing-list">
                                <ul>
                                    <li>Create events</li>
                                    <li>Add tasks</li>
                                    <li>Invite people</li>
                                    <li>Add budget</li>
                                </ul>
                            </div>
                        </div>

                        <div class="pricing-plan-container pro" style="margin-right:0;">
                            <div class="pricing-plan">
                                <div class="pricing-plan-content">
                                    <div class="plan-title">Pro</div>
                                    <div class="pricing-plan-price">
                                        <span class="pricing-plan-currency">€</span>
                                        14
                                        <span class="pricing-plan-cents">.99</span>
                                    </div>

                                    <div class="pricing-plan-price-text">per month</div>
                                </div>
                            </div>

                            <div class="pricing-list">
                                <div class="pricing-list-header">
                                    All planner features +
                                </div>
                                <ul>
                                    <li>Add expenses</li>
                                    <li>Budget calculations</li>
                                    <li>Create food menus</li>
                                    <li>Create food menus</li>
                                    <li>Food suggestions</li>
                                    <li>Receipes</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="plans-container" v-if="false">
                        <div class="pricing-plan-container btn-wrapper" style="margin-left:0;">
                            <a @click="subscribe" href="javascript:{}" class="btn-primary"
                                >SUBSCRIBE <span>€4.99/M</span></a
                            >
                            <div v-if="user && !user.free_trial_used" class="trial">Free trial (30 days)</div>
                        </div>
                        <div class="pricing-plan-container">
                            <div class="coming">Coming soon</div>
                        </div>
                    </div>
                </div>

                <div class="bttn-container unsubscribe" v-if="user && user.active_plan && !user.free_trial_used">
                    <a v-if="false" @click="sub" class="btn-default" href="javascript:{}">Subscribe</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/router";
import PaymentModal from "./payment-modal";
import PaymentChangeModal from "./payment-edit-modal";
import moment from "moment";

export default {
    name: "contact",
    data() {
        return {
            is_trial: true,
            payment_change_modal_shown: false,
            show_payment_modal: false,
            total_sum: 0
        };
    },
    components: { PaymentModal, PaymentChangeModal },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            vm.get_pricing_plans();
            next();
        });
    },
    computed: {
        ...mapState(["user", "user_data_loaded"]),
        show_update_method_block() {
            let d = new Date();
            var endDateMoment = moment(d);
            endDateMoment.add(1, "months");
            let formatted = endDateMoment.format("MM/YYYY");
            if (this.user && this.user.payment_method) {
                if (this.user.payment_method.expiration_date === formatted) {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        ...mapActions(["unsubscribe"]),
        ...mapActions(["delete_user", "get_logged_in_user", "add_free_trial"]),
        ...mapActions(["get_pricing_plans"]),
        unsub() {
            if (confirm("Are you sure?")) {
                this.unsubscribe();
            }
        },
        getDate(date) {
            let day = moment.utc(date.toString(), ["YYYY-MM-DD HH-mm-ss", "YYYY-MM-DD"]);
            day = day.local();
            let lastLoginDate = day.format("MMMM DD, YYYY");
            return lastLoginDate;
        },
        update() {
            this.showPaymentChangeModal();
        },

        closePaymentModal() {
            this.show_payment_modal = false;
        },
        hidePaymentChangeModal() {
            this.payment_change_modal_shown = false;
        },
        showPaymentChangeModal() {
            this.payment_change_modal_shown = true;
        },
        subscribe() {
            if (!this.user.free_trial_used) {
                this.add_free_trial();
            } else {
                this.show_payment_modal = true;
            }
        },
        sub() {
            router.push({ path: "/settings/subscription" });
        }
    },
    mounted() {
        this.get_logged_in_user();
    },
    created() {}
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        padding: 3.2rem 1.6rem 0 1.6rem;
    }
}

p {
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
    color: #000000;
}

.price {
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
    color: #717171;
}

.title {
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
    font-weight: 600;
    color: #000000;
}

.red {
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
    color: #d30000;
    margin-bottom: 2.4rem;
}

.bttn-container {
    display: flex;
    max-width: 50rem;
    margin-bottom: 4.2rem;
}

.bttn-container.unsubscribe,
.btn-container {
    max-width: 30rem;
}

.btn-primary,
.btn-default {
    margin-left: auto;
    margin-top: 4.4rem;
    padding: 0.8rem 1.6rem;
}

p span {
    font-weight: 600;
    font-size: 1.3rem;
    line-height: 2.4rem;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

@media (max-width: 82rem) {
    .main-content {
        padding: 3.2rem 1.6rem 0 1.6rem;
    }
}

.pl-title {
    font-size: 3.4rem;
    line-height: 5rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: #000000;
    margin-top: 4.2rem;
    margin-bottom: 4.2rem;
}

@media (max-width: 820px) {
    .pl-title {
        margin-top: 0;
        margin-bottom: 2.4rem;
        align-self: flex-start;
        font-size: 2rem;
        line-height: 2.4rem;
    }
}

@media (max-width: 820px) {
    .pricing-plan-price {
        font-size: 28px;
        line-height: 32px;
    }

    .pricing-plan-cents {
        font-size: 14px;
        line-height: 20px;
    }

    .pricing-plan-currency {
        font-size: 14px;
        line-height: 20px;
    }

    .pricing-plan-price-text {
        font-size: 11px;
        line-height: 16px;

        letter-spacing: 0.05em;
    }
}

.plans-container {
    display: flex;
    margin-bottom: 4rem;
    width: 100%;
    justify-content: center;
}

@media (max-width: 820px) {
    .plans-container {
        justify-content: initial;
    }
}

@media only screen and (max-width: 680px) {
    .landing .pricing-plan-container {
        padding: 0;
    }
}

.pricing-plan {
    box-shadow: none !important;
    margin-bottom: 2.4rem;
}

.coming {
    padding: 0.8rem 0;
    font-size: 1.4rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #000000;
}

@media (max-width: 820px) {
    .coming {
        font-size: 12px;
        line-height: 24px;
    }
}

.pricing-list {
    font-size: 1.4rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
}

.pricing-list-header {
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    margin-bottom: 1.2rem;
}

@media (max-width: 820px) {
    .pricing-list {
        font-size: 1.2rem;
        line-height: 2.4rem;
        letter-spacing: 0.02em;
    }

    .pricing-list-header {
        font-weight: 600;
        font-size: 1.4rem;
        line-height: 2.4rem;
        margin-bottom: 0;
    }
}

.pricing-plan-content {
    box-shadow: none !important;
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem !important;
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem !important;
    min-height: 8.4rem;
    padding-top: 1.6rem;
}

.landing .pricing-plan-container {
    margin: 0 0.8rem 0rem 0.8rem;
}

.pricing-options {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.plan-title {
    font-size: 1.4rem;
    line-height: 2.8rem;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    font-weight: bold;
    color: #ffffff;
}

.btn-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
}

@media (max-width: 820px) {
    .plan-title {
        font-size: 1.1rem;
        line-height: 2.4rem;
    }
}

.btn-primary {
    padding: 0.8rem 1.6rem;
    font-size: 1.2rem;
    align-items: flex-start; /* NEW */
}

@media (max-width: 820px) {
    .btn-primary {
        font-size: 11px;
    }
}

.trial {
    font-size: 1.4rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.03em;
    color: #717171;
    margin-top: 1.6rem;
}

@media (max-width: 820px) {
    .trial {
        font-size: 12px;
        line-height: 16px;
    }
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.pricing-plan-container .btn-primary {
    margin-left: initial;
    margin-top: 0;
}

.landing .text-container {
    margin-bottom: 4rem;
}

.btn-primary span {
    margin-left: 0.4rem;
    font-weight: 400;
}
</style>
